import React from 'react';
import {
  CopyBlock,
  CopyBlockAlignment,
  CopyBlockProps,
} from '@noths/polaris-client-ribbons-design-system';

import { BlockContainer } from '../BlockContainer/BlockContainer';
import * as styles from './CopyBlockBlock.style';

export const CopyBlockBlock = (props: CopyBlockProps) => (
  <BlockContainer wrapperStyles={styles.wrapper} maxWidth="full" columnsL={8}>
    <CopyBlock {...props} />
  </BlockContainer>
);

export type { CopyBlockProps, CopyBlockAlignment };
